module.exports = __webpack_public_path__ + "img/icon3.50814c9b.svg";